import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatChipInputEvent} from '@angular/material/chips';
import {ENTER, COMMA} from '@angular/cdk/keycodes';
import {SmsModel} from './sms-dialog.model';
import {TypesService} from '../services/types.service';
import {ClientService} from '../services/client.service';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {OAuthService} from 'angular-oauth2-oidc';
import {HistoryService} from '../services/history.service';
import {CommunicationsService} from '../services/communications.service';
import * as _ from 'lodash';
import {Observable} from 'rxjs';
import {FormBuilderService} from '../services/form-builder.service';
import {NgFor, NgIf} from "@angular/common";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatChipsModule} from "@angular/material/chips";
import {MatIconModule} from "@angular/material/icon";
import {MatSelectModule} from "@angular/material/select";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {FmcLibraryNotificationService} from '../services/notification.service';

@Component({
  selector: 'fmc-sms-dialog',
  templateUrl: './sms-dialog.component.html',
  styleUrls: ['./sms-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SmsDialogComponent implements OnInit, OnChanges {
  @Input() recipients: any;
  @Input() appId: number;
  @Input() entityType: string;
  @Input() activeLook: string;
  @Input() public userPartyRoleId: any;
  @Input() public userPartyId: any;
  @Output() public closeDialog = new EventEmitter<any>();

  public sms: any;
  public selectedTemplate: any;
  public smsTags: any = [];
  public globalTemplates: any = [];
  public myTemplates: any = [];
  public filteredGlobalTemplates: any = [];
  public filteredMyTemplates: any = [];
  public defaultControl = new SmsModel().smsForm;
  public formGroup: UntypedFormGroup;

  // the below relates to the chip list
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public separatorKeysCodes = [ENTER, COMMA];
  public phoneList = [];
  public sendToList = [];
  public templateTags: any;
  public types: any = [
    'template-tags'
  ];
  public templateLoading = false;

  constructor(private oauthService: OAuthService,
              public typesService: TypesService,
              public clientService: ClientService,
              public formBuilderService: FormBuilderService,
              public notificationService: FmcLibraryNotificationService,
              public historyService: HistoryService,
              public communicationService: CommunicationsService) {
    this.formGroup = this.defaultControl;
    this.sms = {
      'selectedTag': '',
      'selectedTemplate': '',
      'message': '',
      'recipient': []
    };
  }

  ngOnInit() {
    this.getRecipientsNumber();

    this.getTypes().subscribe(() => {
      this.setupSmsTemplates();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.recipients && !changes.recipients.currentValue) {
      this.formGroup.reset();
      this.phoneList = [];
      this.sms.recipient = [];
    } else if (changes && changes.recipients && changes.recipients.currentValue !== changes.recipients.previousValue && !changes.recipients.firstChange) {
      this.phoneList = [];
      this.sms.recipient = [];
      this.getRecipientsNumber();
    }
  }



  public getRecipientsNumber() {
    if (this.recipients && this.recipients.length > 0) {
      this.recipients.forEach(recipient => {
        console.log('recipient', recipient);
        const partyId = (recipient.PartyID) ? recipient.PartyID : (recipient.party.party) ? recipient.party.party.iD : recipient.party.iD;
        this.clientService.getPartyPhoneList(partyId)
          .subscribe(data => {
            this.pushPhoneNumber(recipient, data);
          });
      });
    }
  }

  public pushPhoneNumber(recipient, data) {
    data.forEach(phone => {
      if (phone.TelephoneTypeID === 3) {
        if (!this.phoneList.find(x => x.phoneNumber === phone.TelephoneNumber.telephoneNumber)) {
          const partyId = (recipient.person && recipient.person.partyID) ? recipient.person.partyID : (recipient.company && recipient.company.partyID) ? recipient.company.partyID : recipient.PartyID;
          const recipientName = (recipient.party && recipient.party.name) ? recipient.party.name : recipient.PartyName;
          this.phoneList.push({phoneNumber: phone.TelephoneNumber.telephoneNumber, recipientName: recipientName});
          this.sms.recipient.push({
            'literal': {
              'mobileNumber': phone.TelephoneNumber.telephoneNumber,
              'partyId': partyId
            }
          });
          this.sendToList.push(recipient);
        }
      }
    });
  }

  public setupSmsTemplates() {
    // get email template tags
    this.clientService.getSmsTemplateTags()
      .subscribe((tags: any) => {
          tags.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));

          tags.forEach(tag => {
            this.smsTags.push(tag);
          });
        },
        error => {
          console.log(error);
        });
  }

  addPhoneNumber(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.phoneList.push({phoneNumber: value.trim()});
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removePhoneNumber(phoneNumber: any): void {
    const index = this.phoneList.indexOf(phoneNumber);

    if (index >= 0) {
      this.phoneList.splice(index, 1);
    }

    const partyIdFound = this.sms.recipient.find(el => el.literal.mobileNumber === phoneNumber.phoneNumber);
    const smsIndex = this.sendToList.findIndex(el => el.partyId = partyIdFound.literal.partyId);

    if (smsIndex >= 0) {
      this.sendToList.splice(smsIndex, 1);
    }

    const mobileFound = this.sms.recipient.findIndex(el => el.literal.mobileNumber === phoneNumber.phoneNumber);
    if (mobileFound >= 0) {
      this.sms.recipient.splice(mobileFound, 1);
    }
  }

  public selectSmsTag(value) {
    if (value === 'freehand') {
      this.sms.selectedTag = value;
    }

    this.templateLoading = true;
    this.clientService.getSmsTemplatesByTag(1000, 0, value).subscribe((templates) => {
      templates.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      this.filteredGlobalTemplates = templates;
      this.templateLoading = false;
    });
  }

  public selectSmsTemplate(value) {
    this.selectedTemplate = value;
    this.sms.selectedTemplate = value;
    this.formGroup.get('message').patchValue(value.message);
  }

  public closeDialogAction() {
    this.closeDialog.emit(true);
  }

  submitSms(data) {
    console.log('form submission ', data);
    console.log('Form Valid?', this.formGroup.valid);
    let smsData = [];
    const payload = {
      id: this.sms.selectedTemplate._id,
      name: this.sms.selectedTemplate.name,
      jsonModel: {},
      override: this.sms.selectedTemplate
    };

    if (this.formGroup.valid && this.sms.recipient.length > 0) {
      if (this.sms.selectedTag === 'freehand') {
        smsData = [{
          'sms': {
            'recipient': this.sms.recipient,
            'message': data.message
          }
        }];
      } else {
        this.sms.recipient.forEach(party => {
          payload.override.message = data.message;
          smsData.push({template: Object.assign({partyId: party.literal.partyId}, payload)});
        });
      }

      this.communicationService.sendSms(smsData)
        .subscribe((status: any) => {
          this.notificationService.notify('success', 'SMS has been sent', 'Success');
          this.clearSmsBody();
          this.closeDialog.emit('sms sent');
          if (this.entityType && this.appId) {
            this.saveSmsHistory(smsData);
          }
        }, (error: any) => {
          this.notificationService.notify('error', 'This SMS could not be sent sent', 'Success');
          console.log(error);
        });
    } else {
      this.formBuilderService.validateAllFormFields(this.formGroup);
      console.log('form is invalid');
      console.log(this.formGroup);
    }
  }

  clearSmsBody() {
    this.formGroup.reset();
  }

  saveSmsHistory(data) {
    // get the logged in user to show who the message is from
    const userDetails: any = this.oauthService.getIdentityClaims();

    const body: any = {};
    const message = (data[0].sms) ? data[0].sms.message : data[0].template.override.message;
    const recipients: any = (data[0].sms) ? data[0].sms.recipient : data[0].template.override.to;
    body.__t = 'sms';
    body.category = 'general';
    body.from = userDetails.name;
    body.message = message;
    body.identities = {
      recipients: []
    };

    this.sms.recipient.forEach((to: any) => {
      const mobileNumber = (to.literal && to.literal.mobileNumber) ? to.literal.mobileNumber : '';
      const partyId = (to.literal && to.literal.partyId) ? to.literal.partyId : null;
      body.identities.recipients.push(partyId);
      body.to = mobileNumber;

      // save copy to history
      this.historyService.createHistoryNote(this.entityType, this.appId, body);
      if (partyId) {
        // save copy to crumbs party
        this.historyService.createHistoryNote('crumbs-party', partyId, body);
      }
    });
  }

  public getTypes(): Observable<any> {
    return new Observable(observer => {
      this.typesService.getTypes(this.types).subscribe(
        lists => {
          lists.forEach((list, index) => {
            this[_.camelCase(this.types[index])] = list;
          });
          observer.next(null);
          observer.complete();
        },
        error => {
          console.log(error);
          observer.error(error);
        });
    });
  }
}
